import { FC } from "react";
import "./chip.scss";

interface ChipComponentTypes {
    label: string;
}

const ChipComponent: FC<ChipComponentTypes> = ({ label }) => {
    return (
        <div className="chip ms-2">
            {label}
        </div>
    );
};

export default ChipComponent;